export default __webpack_public_path__ + "static/media/Yuukke_Cover.9953233a.jpg";